import Api from '../helpers/Api';
import LocalStorage from '../helpers/LocalStorage';
import FileUpload from '../helpers/FileUpload';
import QueryParams from '../helpers/QueryParams';
import AgreementSteps from '../modules/eSigning/shared/AgreementSteps';
import RecieverForm from '../modules/eSigning/shared/RecieverForm';
import BrowserSettings from '../helpers/BrowserSettings';
/**
 * Agreement repository for Esigning
 */
export default class AgreementRepository {
    /**
     * Constructor
     * @param {*} agreementType
     */
    constructor(agreementType) {
        // Api fetch Reciever Data
        this.api = new Api();

        // Storage
        this.storage = new LocalStorage();

        // Steps & views
        this.steps = new AgreementSteps(agreementType);

        // Reciever Data for DropDown
        this.recieverForm = new RecieverForm(agreementType);

        // File upload Helper
        this.fileupload = new FileUpload();

        // Searching url Query Parameters
        this.queryParams = new QueryParams();

        // Endpoint you get from posting to to the api
        this.salesManSigningUrl;
    }

    /**
     * Fetch Reciever data from system
     * @async
     * @param {*} endPoint
     * @returns void
     */
    fetchRecieverDataAsync = async (endpoint) => {
        const response = await this.api.fetchData(endpoint, {
            customerNumber: document.getElementById('customerNumberElementId').value,
        });

        if (response.status === 200) {
            this.recieverForm.setRecieverDropDown(response.body);
        }
    };

    /**
     * Show loader icon and disable button
     * @returns void
     */
    showLoading = () => {
        const loaderIcon = document.querySelector("#agreement-loader");
        const submitButton = document.querySelector(".btnSaveAgreement");
        submitButton.classList.add('disabled');
        loaderIcon.style.display = 'block';
    }

    /**
     * Remove loader icon and enable button
     * @returns void
     */
    removeLoading = () => {
        const loaderIcon = document.querySelector("#agreement-loader");
        const submitButton = document.querySelector(".btnSaveAgreement");
        submitButton.classList.remove('disabled');
        loaderIcon.style.display = 'none';
    }

    /**
     * Show error dialog
     * @returns void
     */
    showGenericErrorDialog = () => {
        const dialog = document.querySelector('#informationDialog');
        const span = dialog.querySelector('span.popup-type');
        span.classList.add('warning');
        dialog.classList.remove('hidden');
    }

    /**
     * Post data to API
     * @async
     * @param {*} endpoint
     * @param {*} storageName
     * @returns void
     */
    commonPostAgreementDataAsync = async (endpoint, storageName) => {
        // Post data with payload
        const payload = this.storage.getItem(storageName);

        this.showLoading();
        const response = await this.api.postData(endpoint, payload);
        this.removeLoading();
        //Prepare for signing document.
        if (response && response.status === 200) {
            this.prepareSigningAsync(response.body, 'commonSigning');
        } else {
            this.showGenericErrorDialog();
        }
    };

    /**
     * Post data to Machine API
     * @async
     * @param {string} endpoint
     * @returns void
     */
    postMachineAgreementDataAsync = async (endpoint) => {
        const payload = this.storage.getItem('machineAgreement');
        const query = this.queryParams.getQueryParamsAsObject();

        if (Object.getOwnPropertyNames(query).length === 0) {
            payload.documents = await this.fileupload.getDocumentList(
                document.querySelector('#agreementFile').files
            );
        }

        this.showLoading();
        const response = await this.api.postData(endpoint, payload);
        this.removeLoading();

        const salesMan = response && response.body.Recipients.Signers.filter((x) => x.IsSalesMan)[0];
        this.salesManSigningUrl = salesMan && salesMan.SigningUrl;

        //Prepare for signing document.
        if (response && response.status === 200) {
            this.prepareSigningAsync(response.body);
        } else {
            this.showGenericErrorDialog();
        }
    };

    /**
     * Open new tab/window to Visma in browser and send sms.
     * @async
     * @param {*} response
     * @param {*} signingType
     * @returns void
     */
    prepareSigningAsync = async (response, signingType) => {
        if (signingType == 'commonSigning') {
            const browserSettings = new BrowserSettings();
            const browserIsBlocked = browserSettings.checkPopUpBlocker();

            // Visma window for signing
            if (document.querySelector('#isInternal').value !== 'true') {
                const newTab = window.open(response.SigningUrl, '_blank');

                if (!browserIsBlocked) {
                    newTab.focus();
                }
                // Confirmation page - Set Signing url on button
                document
                    .querySelector('#openSigningWindow')
                    .setAttribute('href', response.SigningUrl);
            }
        }

        this.steps.stepsViews('showStep4');
    };
}
